<template>
    <div class="view">
        <div class="error-wrap">
            <h2 class="title">Oops!</h2>
            <p>Incorrect URL.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: '404',
};
</script>

<style lang="scss" scoped>
.view {
    flex: auto;
    padding: 30px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    & > * {
        margin: auto;
    }
}
.error-wrap .title {
    color: $color-error;
}
</style>
